import { union } from 'lodash';
import {
  contentDetailPage,
  discountDetailPage,
  discountListPage,
  tcDetailPage,
  tcListPage,
  legalDetailPage,
  legalListPage,
  collectionPage,
  categoryPage,
  maintenancePage,
  promotionTagDetailPage,
  promotionTagListPage,
  productDetailPage,
  productListPage,
  contentListPage,
  settingPage,
} from 'src/tools/permissions/salesChannelPermissions';

const salesChannelContentEdit = (params) => {
  return union(contentDetailPage(params));
};

const salesChannelVersionList = (params, uuid) => {
  return union(
    contentListPage(params),
    contentDetailPage({ ...params, saleChannelUuid: uuid }),
  );
};

const salesChannelProductParent = (params, uuid) => {
  return union(
    productListPage(params),
    productDetailPage({ ...params, saleChannelUuid: uuid }),
    promotionTagDetailPage(params),
    promotionTagListPage(params),
  );
};

const salesChannelProductsList = (params, uuid) => {
  return union(
    productListPage(params),
    productDetailPage({ ...params, saleChannelUuid: uuid }),
  );
};

const salesChannelPromotionTagList = (params) => {
  return union(promotionTagDetailPage(params), promotionTagListPage(params));
};

const salesChannelMaintenance = (params) => {
  return union(maintenancePage(params));
};

const salesChannelCollection = (params) => {
  return union(collectionPage(params));
};

const salesChannelCategory = (params) => {
  return union(categoryPage(params));
};

const salesChannelLegalParent = (params) => {
  return union(
    legalListPage(params),
    legalDetailPage(params),
    tcListPage(params),
    tcDetailPage(params),
  );
};

const salesChannelLegalList = (params) => {
  return union(legalListPage(params), legalDetailPage(params));
};

const salesChannelTCList = (params) => {
  return union(tcListPage(params), tcDetailPage(params));
};

const salesChannelPromotion = (params) => {
  return union(discountListPage(params), discountDetailPage(params));
};

const salesChannelSetting = (params) => {
  return union(settingPage(params));
};

export {
  salesChannelContentEdit,
  salesChannelVersionList,
  salesChannelProductParent,
  salesChannelProductsList,
  salesChannelPromotionTagList,
  salesChannelMaintenance,
  salesChannelCollection,
  salesChannelCategory,
  salesChannelLegalParent,
  salesChannelLegalList,
  salesChannelTCList,
  salesChannelPromotion,
  salesChannelSetting,
};
